export default __webpack_public_path__ + "static/media/home-hero-bf-3.8e49b2cb.png";